import addSeconds from 'date-fns/addSeconds'
import isPast from 'date-fns/isPast'
import { configs } from 'configs'

const EXPIRE_PREFIX = 'expire_'
const getNamespace = () => (configs.NAMESPACE ? `${configs.NAMESPACE}_` : '')
const buildKey = (key, prefix = '') => `${prefix}${getNamespace()}${key}`
const buildExpireKey = key => buildKey(key, EXPIRE_PREFIX)

function getExpirationDate(key) {
  const exp = localStorage.getItem(buildExpireKey(key))
  return new Date(exp || Number.MIN_VALUE)
}

function removePersistent(key) {
  localStorage.removeItem(buildExpireKey(key))
  localStorage.removeItem(buildKey(key))
}

function setPersistent(key, data, expireSeconds = 86400) {
  const expireDate = addSeconds(new Date(), expireSeconds)
  localStorage.setItem(buildExpireKey(key), expireDate.toISOString())
  localStorage.setItem(buildKey(key), JSON.stringify(data))
}

function getPersistent(key) {
  const expiration = getExpirationDate(key)
  const value = localStorage.getItem(buildKey(key))

  if (!value || isPast(expiration)) {
    removePersistent(key)
    return undefined
  }

  if (typeof value === 'string' && value === 'undefined') return undefined

  return JSON.parse(value)
}

function setSession(key, data) {
  sessionStorage.setItem(buildKey(key), JSON.stringify(data))
}

function getSession(key) {
  const value = sessionStorage.getItem(buildKey(key))
  if (!value) return undefined
  if (typeof value === 'string' && value === 'undefined') return undefined
  return JSON.parse(value)
}

function removeSession(key) {
  sessionStorage.removeItem(buildKey(key))
}

export const persistentStore = {
  set: setPersistent,
  get: getPersistent,
  remove: removePersistent,
}

export const sessionStore = {
  set: setSession,
  get: getSession,
  remove: removeSession,
}

export { buildKey, buildExpireKey }
